import { useState, useEffect } from 'react';

export default function Login() {

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [userEmail, setUserEmail] = useState('');
    const [isFormComplete, setIsFormComplete] = useState(false);

    // const [credentials, setCredentials] = useState(null);
    const [hasAccount, setHasAccount] = useState(true);
    const [isCorrectCredentials, setIsCorrectCredentials] = useState(true);

    //code below was used for testing purposes and to clear localStorage afterwards in preparation for
    //a clean slate to save new user account data and be able to retrieve that data at a later time

    //const cachedCreds = localStorage.setItem('credentials', JSON.stringify({userName: 'josephburton', pwd: 'burton1234'}));
    // console.log('Before the storage is cleared', localStorage.getItem('credentials'));
    // localStorage.clear();
    // console.log('After cleared storage', localStorage.getItem('credentials'));
    

    const handleUsername = (e) => {
        setUsername(e.target.value);
        //console.log('username value is:', e.target.value);
    };

    const handlePassword = (e) => {
        setPassword(e.target.value);
        //console.log('Password value is:', e.target.value);
    };
    const handleCreateAccount = () => {
        if (!username || !firstName || !lastName || !userEmail || !password) {
            alert('All fields are required. Try again.');
        } else {
            setIsFormComplete(true);
            alert('Account successfully created');
            //redirect user to login page
            window.location.href = '/Login';
        }
    };
    const  handleLogin = async () => {
        //check local storage if user exists
        //if exists compare entered hashed password with hashed locally stored password
        //if they match allow user to "log in", proceeds to redirect user to home page with a status of logged in
       if (localStorage.getItem('credentials')) {
           let creds = JSON.parse(localStorage.getItem('credentials'));
           setHasAccount(true);
           if (creds.userName !== username || creds.pwd !== password) {
               setIsCorrectCredentials(false);
           } else {
                console.log('Congratulations you\'ve successfully been logged in!');
                setIsFormComplete(true);

                const promise = new Promise((resolve) => {
                    resolve(`Successful login. Welcome username: ${creds.userName}!`);
                })
                promise.then(data => alert(data));
                // console.log('successful?', goods);
                // alert(`Hello ${creds.fName + ' ' + creds.lName}! Welcome to MApp, the Movie App :)`);
                window.location.href = "/";
           }
       } else {
           setHasAccount(false);
       }
   };

    useEffect(() => {
        // save user account to local storage;
        if (isFormComplete) {
            localStorage.setItem('credentials', JSON.stringify({userName: username, pwd: password, fName: firstName, lName: lastName, email: userEmail}));
        }
    }, [isFormComplete]);

    function render() {
        if (window.location.search === '?new_account=true') {
            // console.log('the current URL has a query string!', window.location.search);
            return (
                <div className="content">
                    <div className="top-third">
                        <h2 className="text-primary">Create New Account</h2>
                        <i className="fa-solid fa-clapperboard"></i>
                    </div>
                    <div className="movie-icon">
                        <i className="fa-solid fa-ticket pe-2"></i>
                        <i className="fa-solid fa-ticket"></i>
                    </div>
                    {/* <form method="" action=""> */}
                        <div className="fullname">
                            <input className="first-name mb-3 me-2" type="text" placeholder="first name" onChange={(e) => setFirstName(e.target.value)} autoFocus />
                            <input className="last-name" type="text" placeholder="last name" onChange={(e) => setLastName(e.target.value)} />
                        </div>
                        <div className="input-email mb-1">
                            <input className="email w-75" type="text" placeholder="email address" onChange={(e) => setUserEmail(e.target.value)} />
                        </div>
                        <div className="input-credentials">
                            <input className="w-75 mb-3" type="text" placeholder="Username" onChange={(e) => handleUsername(e)} required/>
                            <input className="w-75 mb-2" type="password" placeholder="Password" onChange={(e) => handlePassword(e)} onKeyUp={(e) => e.key === 'Enter' ? handleCreateAccount(): null} required/>
                        </div>    
                        <div className="login-btn mt-5">
                            <button className="btn btn-success w-75" onClick={() => handleCreateAccount()} >Create New User</button>
                        </div> 
                    {/* </form> */}
                    {!hasAccount && (<div className="text-danger">
                            No account associated with this user. <br/>Please create an account.
                        </div>)
                    }
                    {!isCorrectCredentials && (<div className="text-danger">
                            Invalid credentials. Try again.
                        </div>)
                    }
                    <div className="d-flex justify-content-around links pt-2">
                        {/* <a className="" href="./login?new_account=true">New User? Create Account</a> */}
                        <a href="#">Forgot Password?</a>
                    </div>   
                </div>
                )
        } else {
            return (
                <div className="content">
                    <div className="top-third">
                        <h2 className="text-primary">MApp User Login</h2>
                        <i className="fa-solid fa-clapperboard"></i>
                    </div>
                    <div className="movie-icon">
                        <i className="fa-solid fa-ticket pe-2"></i>
                        <i className="fa-solid fa-ticket"></i>
                    </div>
                    <div className="input-credentials">
                        <input className="w-75 mb-3" type="text" placeholder="Username" onChange={(e) => handleUsername(e)} autoFocus required/>
                        <input className="w-75 mb-2" type="password" placeholder="Password" onChange={(e) => handlePassword(e)} onKeyUp={(e) => e.key === 'Enter' ? handleLogin(): null} required/>
                    </div>    
                    <div className="login-btn mt-5">
                        <button className="btn btn-success w-75" onClick={() => handleLogin()} >Login</button>
                    </div> 
                    {!hasAccount && (<div className="text-danger">
                            No account associated with this user. <br/>Please create an account.
                        </div>)
                    }
                    {!isCorrectCredentials && (<div className="text-danger">
                            Invalid credentials. Try again.
                        </div>)
                    }
                    <div className="links pt-2">
                        <a className="" href="./login?new_account=true">New User? Create Account</a>
                        <a href="#">Forgot Password?</a>
                    </div>   
                </div>
            )
        }
    }

    return (
        <div className="login-splashscreen">
            <div className="shadow-component">
                <div className="login-window">
                    {render()}
                </div>
            </div>
        </div>
    )
}